import React from 'react';
import cx from 'classnames';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { withTranslate } from 'shared/hocs/withTranslate';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FormSelect.css';

const isMobile = __APP__ === 'mobile';

class FormSelect extends React.Component {
  static propTypes = {
    customStyle: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape()
    ]),
    options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    handleChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func,
    fieldName: PropTypes.string.isRequired,
    label: PropTypes.string,
    labelKey: PropTypes.string,
    valueKey: PropTypes.string,
    isLoading: PropTypes.bool,
    t: PropTypes.func.isRequired,
    errors: PropTypes.shape(),
    touched: PropTypes.shape(),
    isRequired: PropTypes.bool,
    clearable: PropTypes.bool,
    searchable: PropTypes.bool,
  };

  static defaultProps = {
    labelKey: 'name',
    valueKey: 'id',
    label: '',
    value: {},
    customStyle: '',
    isLoading: false,
    isRequired: false,
    clearable: false,
    searchable: true,
    errors: {},
    onInputChange: () => {},
    touched: {},
  };

  render() {
    const {
      fieldName,
      label,
      customStyle,
      errors,
      touched,
      isRequired,
      handleChange,
      labelKey,
      valueKey,
      isLoading,
      value,
      options,
      onInputChange,
      clearable,
      searchable,
      t,
    } = this.props;

    return (
      <div className={cx(s.root, customStyle, { [s.rootMobile]: isMobile })}>
        {label &&
          <label className={s.title} htmlFor={fieldName}>
            {label} {isRequired && <span className={s.requiredField}>*</span>}
          </label>}
        <Select
          placeholder={t('Выбрать')}
          noResultsText={t('Результатов не найдено')}
          onChange={val => handleChange(fieldName, val)}
          /* eslint-disable-next-line css-modules/no-undef-class */
          className={errors[fieldName] && touched[fieldName] && s.isInvalid}
          labelKey={labelKey}
          valueKey={valueKey}
          isLoading={isLoading}
          value={value}
          options={options}
          onInputChange={onInputChange}
          clearable={clearable}
          searchable={searchable}
        />
        {errors[fieldName] &&
          touched[fieldName] &&
          <span className={cx(s.errorMessage, { [s.errorMessageMobile]: isMobile })}>
            {errors[fieldName]}
          </span>}
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(FormSelect));



// WEBPACK FOOTER //
// ./src/shared/components/insurance/components/FormSelect/FormSelect.js